<div class="layout-footer">
    <span class="font-medium ml-2">Rajvanta Essentials (v{{version}})</span>
</div>